import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const BinsAbove = ({ binsAbove }: { binsAbove: number }) => {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center">
      <Typography
        color="white"
        fontSize="1.4rem"
        fontWeight={500}
        lineHeight="1"
      >
        {binsAbove}
      </Typography>
      <Typography
        color="white"
        fontSize=".9rem"
        fontWeight={500}
        whiteSpace="nowrap"
      >
        {t("bins down")}
      </Typography>
    </Stack>
  );
};
